import { animated, useSpring } from '@react-spring/web';
import React from 'react';
import { usePodState } from '../../helpers/podHelper';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import Logo from '../Logo/Logo';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import HumanTag from '../UserNavigator/HumanTag';

const UserRow = () => {
  return (
    <Flexbox className='endorsment_container__user_row' justifyContent='space-between'>
      <Flexbox gap='0.5rem'>
        <Logo src={'https://picsum.photos/id/4/200/300'} width={'2rem'} height={'2rem'} borderRadius='50%' />
        <ThemedText.H5 weight='medium'>Pash</ThemedText.H5>
        <HumanTag />
      </Flexbox>
      <Flexbox gap='0.25rem'>
        <ThemeLogo className={'endorsment_container__action_logo'} icon={'greenTick'} />
        <ThemeLogo className={'endorsment_container__action_logo'} icon={'redCloseCircle'} />
      </Flexbox>
    </Flexbox>
  );
};

const Endorsment = () => {
  const [{ addPeer, backToHome }] = usePodState();

  const springProps = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 200, friction: 30 },
    width: '100%',
    height: '100%',
  });

  return (
    <animated.div className='identity_wrapper__animation' style={springProps}>
      <FlexboxColumn gap='2rem' className='endorsment_container' fw>
        <FlexboxColumn>
          <ThemedText.H5 weight='semi-bold'>Peer Endorsment</ThemedText.H5>
          <Flexbox>
            <Flexbox className='endorsment_container__square active' onClick={addPeer}>
              +
            </Flexbox>
            <Flexbox className='endorsment_container__square'>+</Flexbox>
            <Flexbox className='endorsment_container__square'>+</Flexbox>
            <Flexbox className='endorsment_container__square'>+</Flexbox>
          </Flexbox>
        </FlexboxColumn>

        <FlexboxColumn gap='0'>
          <ThemedText.H5 weight='semi-bold'>Your Unique Request Code:</ThemedText.H5>
          <Flexbox gap='0.5rem'>
            <ThemedText.H3 weight='bold'>41591</ThemedText.H3>
            <Flexbox className='endorsment_container__badge' gap='0rem'>
              <ThemedText.P>30s</ThemedText.P>
              <ThemeLogo icon={'binLogo'} />
            </Flexbox>
          </Flexbox>
        </FlexboxColumn>

        <FlexboxColumn fw>
          <ThemedText.H5 weight='medium'>Handshake Endorsements</ThemedText.H5>
          <FlexboxColumn gap='0.5rem' fw>
            <UserRow />
            <UserRow />
            <UserRow />
          </FlexboxColumn>
        </FlexboxColumn>

        <ThemedText.P className='backToHome' onClick={backToHome}>
          GO BACK TO HOME
        </ThemedText.P>
      </FlexboxColumn>
    </animated.div>
  );
};

export default Endorsment;
